// What a coupon applies to (a course/category or a test series): labels, the item pickers used by the
// coupon form and the table's target filter, and the translation of the toolbar state into the
// parameters of GET /api/assessment/admin/coupons.

export const TARGET_TYPES = [
  { value: "CATEGORY", label: "Course" },
  { value: "SERIES", label: "Test Series" },
];

export const targetTypeLabel = (type) => TARGET_TYPES.find((t) => t.value === type)?.label ?? "—";

const SERIES_STATUS_LABEL = { DRAFT: "Draft", PUBLISHED: "Published" };

// Options for the NEW-coupon picker: only what a student can actually buy. Courses must be premium and
// active; series must be premium and Draft or Published (Draft stays so coupons can be prepared before
// launch; Archived is left out). Series options carry their status so duplicate names can be told apart.
export function buildPickerOptions(targetType, courses = [], series = []) {
  if (targetType === "CATEGORY") {
    return courses
      .filter((c) => c.accessType === "PREMIUM" && c.active)
      .map((c) => ({ id: c.id, label: c.name }));
  }
  if (targetType === "SERIES") {
    return series
      .filter((s) => s.accessType === "PREMIUM" && SERIES_STATUS_LABEL[s.status])
      .map((s) => ({ id: s.id, label: `${s.name} (${SERIES_STATUS_LABEL[s.status]})` }));
  }
  return [];
}

// Options for the table's Target filter: every course or series, unrestricted, so a coupon on an
// inactive course or an archived series can still be found.
export function buildFilterOptions(targetType, courses = [], series = []) {
  if (targetType === "CATEGORY") return courses.map((c) => ({ id: c.id, label: c.name }));
  if (targetType === "SERIES") return series.map((s) => ({ id: s.id, label: s.name }));
  return [];
}

// Toolbar state -> listCoupons parameters. Empty values are omitted; the search is trimmed; a target is
// only meaningful together with its type and is sent as categoryId or seriesId; the status filter is
// sent as active (false is kept).
export function buildListParams({
  page = 0,
  size = 25,
  search = "",
  targetType = "",
  targetId = "",
  status = "",
  discountType = "",
} = {}) {
  const params = { page, size };
  const code = String(search ?? "").trim();
  if (code) params.code = code;
  if (targetType) {
    params.targetType = targetType;
    if (targetId !== "" && targetId != null) {
      if (targetType === "CATEGORY") params.categoryId = targetId;
      else params.seriesId = targetId;
    }
  }
  if (status === "ACTIVE") params.active = true;
  if (status === "INACTIVE") params.active = false;
  if (discountType) params.discountType = discountType;
  return params;
}
